import React from "react";
import { ShieldIcon, ChevronRightIcon } from "../Auth/onboarding/icons";

export default function SecurityBanner() {
  return (
    <section className="dash-improve ist-security-banner">
      <div className="dash-improve-lead">
        <span className="dash-improve-icon">
          <ShieldIcon />
        </span>
        <div>
          <strong>Your data is safe and secure</strong>
          <span>We follow industry best practices to keep your and your users&apos; data protected.</span>
        </div>
      </div>

      {/* Leaves the app, so a link rather than a button - it has to be
          openable in a new tab and reachable by its URL. noreferrer comes
          with target="_blank" to close the window.opener hole. */}
      <a
        href="https://www.hostor.ai/terms/"
        target="_blank"
        rel="noreferrer"
        className="onboarding__btn onboarding__btn--secondary ist-security-btn"
      >
        View security details
        <ChevronRightIcon />
      </a>
    </section>
  );
}
